import { initializeApp } from 'firebase/app'
import { User, getAuth } from 'firebase/auth'

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGE_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_SENDER_ID,
}

const app = initializeApp(firebaseConfig)

export const auth = getAuth(app)

export type FireBaseUser = User | null

export const handleLoginError = (error: string) => {
  if (error.includes('auth/too-many-requests')) {
    return 'auth/too-many-requests' // アカウント一時ロックだけハンドリング
  }

  return 'auth/error'
}
